import { observer } from "mobx-react-lite";
import { GraphData } from "../utils/graph";
import { Box, Skeleton, Stack, Text } from "@mantine/core";
import Chart from "react-google-charts";
import { FullSegmentLatencyResponse } from "../apiResponses/realtimeResponse";
import NoRecordsIcon from "../assets/icons/NoRecordsIcon";

interface ElvLatencyGraphProps {
  data: FullSegmentLatencyResponse | null;
  height: number;
}

const ElvLatencyGraph: React.FC<ElvLatencyGraphProps> = observer(
  ({ data, height }) => {
    if (data === null) {
      return <Skeleton height={height * 0.9} width="80%" mt={height * 0.1} />;
    } else if (data.length <= 1) {
      const color = "#807B75";
      return (
        <Box
          h={height * 0.9}
          w="80%"
          mt={height * 0.1}
          style={{ justifyContent: "center", alignItems: "center" }}
          display="flex"
          bg="#F7F7F7"
        >
          <Stack align="center">
            <NoRecordsIcon color={color} />
            <Text c={color} size="sm">
              No data
            </Text>
          </Stack>
        </Box>
      );
    }

    let total = 0;
    const graphData = [
      ["Bin", "Percent"],
      ...data
        .map((v) => {
          total += v.count;
          return [v.label, v.count] as [string, number];
        })
        .map((v: [string, number]) => [v[0], (v[1] / total) * 100]),
    ];

    const graphOptions = {
      orientation: "horizontal",
      colors: ["#BD6DFF"],
      legend: { position: "bottom" },
      chartArea: {
        width: "80%",
        height: "60%",
      },
      hAxis: {
        textStyle: {
          fontSize: 12,
        },
      },
    };

    return (
      <Box h={`${height}px`} w="100%">
        <Chart
          chartType="BarChart"
          width="100%"
          height={`${height}px`}
          data={graphData}
          options={graphOptions}
        />
      </Box>
    );
  },
);

export default ElvLatencyGraph;
